import { render } from "./specs-noumenon-screen.vue?vue&type=template&id=7c3e2336&scoped=true"
import script from "./specs-noumenon-screen.vue?vue&type=script&lang=js"
export * from "./specs-noumenon-screen.vue?vue&type=script&lang=js"

import "./specs-noumenon-screen.vue?vue&type=style&index=0&id=7c3e2336&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3e2336"]])

export default __exports__